import React from 'react';
import ReactDOM from 'react-dom';
import DrillsApp from './components/App/App';

const root = document.getElementById('app-container');

ReactDOM.render(<DrillsApp />, root);
